var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountStepsCompletedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.086 331.836C227.441 342.48 210.059 342.48 199.414 331.836L136.914 269.336C126.27 258.691 126.27 241.309 136.914 230.664C147.559 220.02 164.941 220.02 175.586 230.664L218.75 273.828L324.414 168.164C335.059 157.52 352.441 157.52 363.086 168.164C373.73 178.809 373.73 196.191 363.086 206.836L238.086 331.836ZM500 250C500 388.086 388.086 500 250 500C111.914 500 0 388.086 0 250C0 111.914 111.914 0 250 0C388.086 0 500 111.914 500 250ZM250 46.875C137.793 46.875 46.875 137.793 46.875 250C46.875 362.207 137.793 453.125 250 453.125C362.207 453.125 453.125 362.207 453.125 250C453.125 137.793 362.207 46.875 250 46.875Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStepsCompletedTick);
export default __webpack_public_path__ + "static/media/account-steps-completed-tick.520cf5a98520f5a8682273581f04edfc.svg";
export { ForwardRef as ReactComponent };